import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=737c49a1&"
import script from "./Approval.vue?vue&type=script&lang=js&"
export * from "./Approval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('737c49a1')) {
      api.createRecord('737c49a1', component.options)
    } else {
      api.reload('737c49a1', component.options)
    }
    module.hot.accept("./Approval.vue?vue&type=template&id=737c49a1&", function () {
      api.rerender('737c49a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Approval/Approval/Approval.vue"
export default component.exports